import React, { lazy } from 'react'
import { Route } from 'react-router'
import { LoggedInRoute } from '@/router/LoggedInRoute'
import { SubRouter } from '@/router/SubRouter'
import { MaintenanceAircraftRouter } from './aircraft/_router'
import { MaintenanceAssessmentRouter } from './assessments/_router'
import { MaintenanceDefectRouter } from './defects/_router'
import { MaintenanceDirectiveRouter } from './directives/_router'
import { MaintenanceFleetRouter } from './fleet/_router'
import { MaintenanceImportRouter } from './imports/_router'
import { MaintenancePlannerRouter } from './planner/_router'
import { MaintenanceProgrammeRouter } from './programmes/_router'
import { MaintenancePublicationRouter } from './publications/_router'
import { MaintenanceWorkOrderRouter } from './work-orders/_router'

const Index = lazy(() => import('./Index'))
const ConfigIndex = lazy(() => import('./config/Index'))
const SlotsIndex = lazy(() => import('./slots/Index'))

//	///////////////////////
//	MARK: EXPORTS
export const MaintenanceRouter = React.memo(() => (
  <SubRouter loggedIn roles={['role--maintenance']}>
    <Route index element={<Index />} />
    <Route path='aircraft/*' element={<MaintenanceAircraftRouter />} />
    <Route path='fleet/*' element={<MaintenanceFleetRouter />} />
    <Route path='planner/*' element={<MaintenancePlannerRouter />} />
    <Route path='programmes/*' element={<MaintenanceProgrammeRouter />} />
    <Route path='directives/*' element={<MaintenanceDirectiveRouter />} />
    <Route path='publications/*' element={<MaintenancePublicationRouter />} />
    <Route path='assessments/*' element={<MaintenanceAssessmentRouter />} />
    <Route path='work-orders/*' element={<MaintenanceWorkOrderRouter />} />
    <Route path='defects/*' element={<MaintenanceDefectRouter />} />
    <Route path='imports/*' element={<MaintenanceImportRouter />} />
    <Route
      path='slots/*'
      element={
        <LoggedInRoute roles={['role--maintenance--fleet']}>
          <SlotsIndex />
        </LoggedInRoute>
      }
    />
    <Route
      path='config/*'
      element={
        <LoggedInRoute roles={['role--maintenance--config']}>
          <ConfigIndex />
        </LoggedInRoute>
      }
    />
  </SubRouter>
))
